import styles from './SaveButton.module.css'
import classNames from 'classnames'
import CheckIcon from '@mui/icons-material/Check'

interface SaveButtonProps {
    className?: string
    onClick?: (event: any) => void
}

export const SaveButton = (props: SaveButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const saveButtonClasses = classNames(styles.SaveButton, className)

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={saveButtonClasses}
            onClick={handleButtonClick}
            type="submit"
        >
            <span className={styles.SaveButton__Caption}>
                Save Changes
            </span>            
        </button>
    )
}